import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import * as ReduxDOMRender from 'redux-stores/ReduxDOMRender';

import ContainerTestOrdersView from './ContainerTestOrdersView';
import EntityTestOrdersTabState from './EntityTestOrdersTabState';

export default class ContainerTestOrdersTabView extends BufferTabView<EntityTestOrdersTabState> {
  override render(): this {
    const modelId = this.model.get('modelId');
    ReduxDOMRender.renderToDOM(<ContainerTestOrdersView containerId={modelId} />, this.el);
    return this;
  }

  override remove(): Backbone.View<EntityTestOrdersTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ContainerTestOrdersTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
